import styled from 'styled-components';

export const SearchBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid ${({ theme }) => theme.colorsInObjects.gray[600]};
  border-radius: ${({ theme }) => theme.radius.s};
  padding: ${({ theme }) => theme.spacing.s};
  & span {
    background-color: transparent !important;
    &:before {
      background-color: ${({ theme }) => theme.colors.verdigris};
      width: ${({ theme }) => theme.spacing.sm};
      height: ${({ theme }) => theme.spacing.sm};
    }
  }
  & .radio-with-label-label {
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    font-size: ${({ theme }) => theme.fontSize.s};
    color: ${({ theme }) => theme.colors.dimGray};
    letter-spacing: 0;
    line-height: ${({ theme }) => theme.lineHeight.lh5};
  }
  & .control-radio-overflow INPUT {
    display: none;
  }
`;

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${({ theme }) => theme.spacing.s};
`;

export const StyledTextLabel = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;
